import { render, staticRenderFns } from "./OrderConfig.vue?vue&type=template&id=77e1d69c"
import script from "./OrderConfig.vue?vue&type=script&lang=js"
export * from "./OrderConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports